<template>
  <v-app class="blue lighten-5">
    <v-snackbar v-model="toast.active" :top="true" :color="toast.color" :timeout="4000">
        {{ toast.text }}
    </v-snackbar>
    <v-dialog v-model="modal.active" max-width="350">
        <v-card>
            <v-card-title>{{ modal.title }}</v-card-title>
            <v-card-text>
                {{ modal.text }}
            </v-card-text>
            <v-card-actions>
                <v-spacer />
                <v-btn @click="cancel()" text>Cancel</v-btn>
                <v-btn color="primary" @click="ok()" dark depressed>OK</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
    <Navbar />
    <v-content>
        <v-progress-linear :indeterminate="true" v-if="!loaded" />
        <router-view v-if="loaded && hasAccess"></router-view>
    </v-content>
    <v-footer class="mt-9" dark padless>
        <v-card flat tile flex min-width="100%" class="primary darken-3 white--text text-center">
            <v-card-text class="white--text" v-html="brand.footer"></v-card-text>
        </v-card>
    </v-footer>
    </v-app>
</template>

<style lang="scss">
    @import "./style/custom.scss";
</style>

<script>
import Navbar from '@/components/Navbar'
import store from "@/services/store";
import modals from "@/services/modals";
import { reauth } from "@/services/api";
import numeral from "numeral";
import theme from "@/services/theme"

export default {
  components: { Navbar },
  data: () => ({
      loaded: false,
      brand: theme.branding
  }),
  store,
  async created() {
      this.$store.commit("init");

      await reauth();

      if (!this.hasAccess)
          this.$router.replace("/login");

      try
      {
        numeral.register('locale', 'ch', {
            delimiters: {
                thousands: "'",
                decimal: '.'
            }
        });

        numeral.locale("ch");
      }
      // eslint-disable-next-line no-empty
      catch { }

      this.loaded = true;
      this.$store.commit("mutate", { inited: true });
  },
  methods: {
    ok: () => modals.ok(),
    cancel: () => modals.cancel()
  },
  computed: {
    hasAccess() {
      return (store.state.authed || this.$route.name === "Login");
    },
    modal: () => store.state.modal,
    toast: () => store.state.toast
  }
};
</script>